import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Preload extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.string),
    start: PropTypes.bool,
    onLoaded: PropTypes.func,
  }

  static defaultProps = {
    items: [],
    start: true,
  }

  constructor(...args) {
    super(...args)

    this.state = {
      completedItems: [],
      failedItems: [],
      loading: false,
    }
  }

  componentDidMount() {
    if (this.props.start) this.startLoading()
  }

  componentWillReceiveProps(nextProps) {
    const { start } = this.props
    const { start: willStart } = nextProps

    if (!start && willStart) this.startLoading()
  }

  startLoading() {
    const { items, onLoaded } = this.props

    const promises = items.map(this.imageLoader.bind(this))

    Promise.all(promises)
      .then(() => {
        if (onLoaded) onLoaded()
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.setState({ loading: false })
      })
  }

  imageLoader(src) {
    return new Promise((res, rej) => {
      const tmpImage = new Image()

      tmpImage.onload = () => {
        this.setState({
          completedItems: this.state.completedItems.concat([src]),
        })
        res()
      }

      tmpImage.onerror = (error) => {
        this.setState({ failedItems: this.state.failedItems.concat([src]) })
        console.error(error)
        rej()
      }

      tmpImage.src = src
    })
  }

  calcPercentDone() {
    const { completedItems, failedItems } = this.state
    const { items } = this.props

    return (completedItems.length + failedItems.length) / items.length
  }

  render() {
    const { completedItems, failedItems, loading } = this.state
    const percentDone = this.calcPercentDone()
    const loaded = !loading && percentDone >= 1

    return this.props.children(loaded, percentDone, completedItems, failedItems)
  }
}



// WEBPACK FOOTER //
// ./src/components/Preload.js